import { render, staticRenderFns } from "./change-claim-type.vue?vue&type=template&id=62182986&"
import script from "./change-claim-type.vue?vue&type=script&lang=js&"
export * from "./change-claim-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports